import {
    Box,
    chakra,
    Flex,
    ListItem,
    UnorderedList,
} from '@chakra-ui/react';

import FloatingUpdate from '../Components/FloatingUpdate';
import { useLanguage } from '../i18n/LanguageContext';
import { HOME_CONTENT } from '../i18n/translations';

const HomePage = () => {
    const { language, t } = useLanguage();
    const content = HOME_CONTENT[language];

    return (
        <Box
            bg="#edf3f8"
            p={50}
        >
            <FloatingUpdate />
            <Box maxW="1100px" margin="auto">
            <Box textAlign="left" mb={6}>
                <chakra.h3
                    fontWeight={'bold'}
                    fontSize={32}
                    color={'blue.400'}>
                    {t('common.introduction')}
                </chakra.h3>
                <chakra.h1
                    py={5}
                    fontSize={40}
                    fontFamily={'Work Sans'}
                    fontWeight={'bold'}
                    color={'gray.700'}>
                    {t('home.title')}
                </chakra.h1>
            </Box>
            <Flex
                boxShadow={'lg'}
                alignItems={'center'}
                width={'100%'}
                rounded={'xl'}
                p={10}
                position={'relative'}
                bg={'white'}
                _after={{
                    content: '""',
                    position: 'absolute',
                    height: '50px',
                    width: '50px',
                    left: '25px',
                    top: '-20px',
                    backgroundSize: 'cover',
                    backgroundImage: "url('/quotation_marks.png')",
                }}>
                <Box
                    textAlign={'left'}>
                    <Box
                        fontFamily={'Inter'}
                        fontWeight={'medium'}
                        fontSize={'20px'}
                        pb={4}
                    >
                        <chakra.p mb={4}>{content.opening}</chakra.p>
                        <UnorderedList mb={5}>
                            {content.bullets.map((item) => <ListItem key={item} mb={2}>{item}</ListItem>)}
                        </UnorderedList>
                        {content.paragraphs.map((paragraph, index) => (
                            <chakra.p key={paragraph} mb={index < content.paragraphs.length - 1 ? 5 : 0}>
                                {paragraph}
                            </chakra.p>
                        ))}
                    </Box>
                </Box>
            </Flex>
            </Box>
        </Box>
    )
}
export default HomePage;
